import React from 'react';
import ReactDOM from 'react-dom';
import RootApp from './RootApp';
// import { register } from './serviceWorker';

const render = () => ReactDOM.render(<RootApp />, document.getElementById('root'));

// // If you want your app to work offline and load faster, you can change
// // unregister() to register() below. Note this comes with some pitfalls.
// // Learn more about service workers: https://bit.ly/CRA-PWA
// register(); // TODO: ajsutar service worker dando falha por trás do nginx/amplify (The script resource is behind a redirect, which is disallowed.)
render();

if (module.hot) {
  module.hot.accept('./RootApp', render);
}
